import Globe from "../Assets/Globe.png";
import G1 from "../Assets/G1.png";
import G2 from "../Assets/G2.png";
import G3 from "../Assets/G3.png";
import Hand from "../Assets/Aboutasset.png";
import Write from "../Assets/Write.png";
import { useEffect, useRef } from "react";
import Businessbox from "../components/bussinessblocks";
import { useNavigate } from "react-router-dom";

export default function About() {
  const topRef = useRef<HTMLDivElement>(null); // Specify the type here
  const navigate = useNavigate();

  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <section
      ref={topRef}
      className=" bg-gradient-to-r from-gray-800 to-gray-900 text-white py-20"
    >
      <div className="container mx-auto flex flex-col items-center justify-center w-full ">
        <div className="w-full flex flex-col justify-center items-center px-4 py-4 ">
          <h1 className="text-2xl md:text-4xl font-extrabold mt-20 text-center md:text-left">
            About Us
          </h1>
          <p className="text-gray-300 my-4 text-center md:text-left ">
            Voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            Excepteur sint occaecat cupidatat non proident.
          </p>
          <div className="mt-6 flex    gap-3 ">
            <a
              onClick={() => {
                navigate("/signup");
              }}
              className=" bg-blue-500 text-white px-4 py-3 rounded-lg mr-4 hover:bg-blue-600 cursor-pointer"
            >
              Get Started
            </a>
            <a
              href="/"
              className="bg-transparent border border-gray-400 text-white px-4 py-3 rounded-lg hover:border-white hover:text-white"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>
      <section className="bg-[#2B659629] text-white h-auto md:h-auto py-10 md:py-20 mt-10  ">
        <div className="flex flex-col md:flex-row justify-between p-4 w-full gap-10 h-full md:w-[80%] md:m-auto">
          {/* Left Section */}
          <div className="text-left md:w-1/2 p-8 flex flex-col justify-center">
            <div className="w-full md:max-w-md">
              <h1 className="text-2xl md:text-4xl font-bold mb-10 p-3 text-center md:text-left">
                We Have Built a Platform to Buy and Sell Shares
              </h1>
              <ul className="space-y-8 text-left p-3">
                {/* First Item */}
                <li className="flex items-start space-x-6">
                  <div className="">
                    <img
                      src={G1}
                      alt="Decentralized Platform icon"
                      className="custom-icons"
                    />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold">
                      Decentralized Platform
                    </h3>
                    <p className="text-gray-400">
                      The platform helps investors to make it easy to purchase
                      and sell their tokens.
                    </p>
                  </div>
                </li>
                {/* Second Item */}
                <li className="flex items-start space-x-6">
                  <div className="">
                    <img
                      src={G2}
                      alt="Crowd Wisdom icon"
                      className="custom-icons"
                    />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold">Crowd Wisdom</h3>
                    <p className="text-gray-400">
                      The process of taking into account the collective opinion
                      of a group.
                    </p>
                  </div>
                </li>
                {/* Third Item */}
                <li className="flex items-start space-x-6">
                  <div className="">
                    <img
                      src={G3}
                      alt="Rewards Mechanism icon"
                      className="custom-icons"
                    />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold">Rewards Mechanism</h3>
                    <p className="text-gray-400">
                      The system pays a bonus for excellent individuals.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* Right Section */}
          <div className="flex justify-center md:w-1/2 items-center">
            <img
              src={Globe}
              alt="A globe representing global trading"
              className="w-3/4 md:w-full h-auto max-w-xs md:max-w-md lg:max-w-lg xl:max-w-xl"
            />
          </div>
        </div>
      </section>

      {/* Ready Documents section */}
      <section className="flex bg-gradient-to-r from-gray-800 to-gray-900 text-white py-20 md:h-auto ">
        <div className="flex flex-col md:flex-row justify-between p-4 w-full gap-10 h-full md:w-[80%] md:m-auto">
          {/* Left Section */}
          <div className="text-center md:text-left p-5 md:w-1/2 flex flex-col justify-between">
            <div className="p-4 w-full">
              <div>
                <label className="text-2xl md:text-4xl font-bold mb-8">
                  Read Our Documents
                </label>
                <h3 className="mt-5 w-full">
                  Here are our full documents that help you to understand deeply
                  about us and our operation.
                </h3>
              </div>
              <div className="flex flex-col justify-between py-6 md:">
                <div className="flex flex-col md:flex-row justify-between py-6 gap-10">
                  <div className="flex gap-4">
                    <div>
                      <img src={Write} alt="Document 1" />
                    </div>
                    <div className="mt-2">
                      <h3>Lorem ipsum dolor</h3>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div>
                      <img src={Write} alt="Document 2" />
                    </div>
                    <div className="mt-2">
                      <h3>Lorem ipsum dolor</h3>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row justify-between py-6 gap-10">
                  <div className="flex gap-4">
                    <div>
                      <img src={Write} alt="Document 3" />
                    </div>
                    <div className="mt-2">
                      <h3>Lorem ipsum dolor</h3>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div>
                      <img src={Write} alt="Document 4" />
                    </div>
                    <div className="mt-2">
                      <h3>Lorem ipsum dolor</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-6">
                <a
                  href="/"
                  className="bg-blue-500 text-white px-6 py-3 rounded-lg mr-4 hover:bg-blue-600"
                >
                  Get Started
                </a>
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className="w-full md:w-1/2 flex justify-center items-center md:h-full">
            <img
              src={Hand}
              alt="Hand reaching out"
              className="w-3/4 md:w-full h-auto max-w-xs md:max-w-md lg:max-w-lg xl:max-w-xl"
            />
          </div>
        </div>
      </section>

      <Businessbox />
    </section>
  );
}
